;; TODO: There is a views/browser_extension feature folder,
;;       so the code in this namespace should belong in that feature folder,
;;       instead of being at top-level of the application
(ns dashboard.browser-extension
  (:require [clojure.string :as str]
            [cognitect.transit :as t]
            [dashboard.entity.questionnaire.db :as questionnaire.db]
            [dashboard.notifications :as notifications]
            [dashboard.services.http-config :as http-config]
            [dashboard.subs :as subs]
            [dashboard.views.browser-extension.client-environments.config :as client-envs-config]
            [dashboard.views.browser-extension.new-questionnaire.config :as new-questionnaire-config]
            [dashboard.views.browser-extension.questionnaire-list.config :as questionnaire-list-config]
            [dashboard.views.browser-extension.questionnaire.config :as questionnaire-config]
            [re-frame.core :as rf]))

(defn section-by-id
  "Returns section by id in the given sequence of section maps."
  [sections id]
  (some->> sections (filter #(= id (:id %))) first))

(defn section-by-name
  "Returns section by name in the given sequence of section maps."
  [sections name]
  (some->> sections (filter #(= name (:name %))) first))

(rf/reg-event-fx
 ::set-env-history
 (fn [{:keys [db]} [_ env-history]]
   {:db (assoc-in db [:browser-extension :env-history] env-history)
    :dispatch [::send-event {:type :initialized}]}))

(rf/reg-sub
 ::sections
 (fn [db [_ questionnaire-id]]
   (sort-by :ordinal (get-in db [:questionnaires questionnaire-id :sections :data]))))

(rf/reg-sub
 ::approved-questions
 (fn [db [_ questionnaire-id]]
   (let [questions (get-in db [:questionnaires questionnaire-id :questions :data])]
     (filter (fn [{:keys [status]}]
               (= status "approved"))
             questions))))

(rf/reg-event-fx
 ::fetch-sections
 (fn [{:keys [db]} [_ questionnaire-id]]
   {:db (assoc-in db [:questionnaires questionnaire-id :sections] {:loading true})
    :http-xhrio {:method :get
                 :uri (str "/api/questionnaires/" questionnaire-id "/sections")
                 :timeout http-config/timeout
                 :format http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :on-success [::fetch-sections-success questionnaire-id]
                 :on-failure [::fetch-sections-failed questionnaire-id]}}))

(rf/reg-event-db
 ::fetch-sections-success
 (fn [db [_ questionnaire-id sections]]
   (assoc-in db [:questionnaires questionnaire-id :sections] {:loading false
                                                              :data sections})))

(rf/reg-event-fx
 ::fetch-sections-failed
 (fn [{:keys [db]} [questionnaire-id _]]
   {:db (assoc-in db [:questionnaires questionnaire-id :sections] {:loading false})
    :dispatch [::notifications/add {:message "Could not fetch questionnaire sections"}]}))

(rf/reg-event-fx
 ::select-question
 (fn [{:keys [db]} [_ content focus-host-element?]]
   (let [questionnaire-id (-> db :route :path-params :id uuid)
         question (->> (get-in db [:questionnaires questionnaire-id :questions :data])
                       (keep #(when (and content
                                         (= (:content %)
                                            content)
                                         (= (:section-id %)
                                            (get-in db [:browser-extension :selected-section :id])))
                                %))
                       first)
         element (get-in db [:browser-extension :question-elements (:id question)])
         section (section-by-id (get-in db [:questionnaires questionnaire-id :sections :data]) (:section-id question))]
     (when element
       (.scrollIntoView element #js{:behavior "smooth"
                                    :block "center"}))
     (if (and content question)
       {:db (-> db
                (assoc-in [:browser-extension :selected-question] question)
                (assoc-in [:browser-extension :selected-section] section))
        :fx [[:dispatch [::send-event {:type :question-selected
                                       :content content
                                       :question question
                                       :focus focus-host-element?}]]
             [:dispatch [::send-event {:type :section-selected
                                       :content section
                                       :questions (get-in db [:questionnaires questionnaire-id :questions :data])
                                       :question question
                                       :focus focus-host-element?}]]]}
       {:db (assoc-in db [:browser-extension :selected-question] nil)}))))

(rf/reg-event-fx
 ::deselect-question
 (fn [{:keys [db]} [_]]
   {:db (-> db
            (assoc-in[:browser-extension :selected-question] nil)
            (assoc-in [:browser-extension :selected-question-data] nil))
    :fx [[:dispatch [::send-event {:type :question-selected :content nil :focus false}]]]}))

(rf/reg-event-fx
 ::create-question
 (fn [{:keys [db]} [_ context content follow-up?]]
   (let [questionnaire-id (-> db :route :path-params :id uuid)
         selected-question (-> db :browser-extension :selected-question)
         selected-section-id (-> db :browser-extension :selected-section :id)
         question {:parent-id (when follow-up?
                                (:id selected-question))
                   :content content
                   :display-name nil
                   :ordinal (-> selected-question
                                :ordinal
                                (or (-> (get-in db [:questionnaires questionnaire-id :questions :data])
                                        count))
                                inc)
                   :data {:element-context context}
                   :section-id selected-section-id
                   :source-type "portal"
                   :comment-required true}]
     ;; Sanity check to make sure current section and selected question's section are the same.
     (cond
       (nil? selected-section-id)
       {:dispatch [::notifications/add {:message "Create or select a section before adding questions"
                                        :class "is-info"}]}

       (or (nil? selected-question)
           (= (:section-id selected-question) selected-section-id))
       (do
         (prn "Sending Question " question)
         {:http-xhrio {:method :post
                       :uri (str "/api/questionnaires/" questionnaire-id "/questions")
                       :params question
                       :timeout http-config/timeout
                       :format http-config/transit-request-format
                       :response-format http-config/transit-response-format
                       :on-success [::create-question-success]
                       :on-failure [::create-question-failed]}
          :db (assoc-in db [:browser-extension :selected-question] nil)})

       :else
       {:dispatch [::notifications/add {:message "Current section and current question's section do not match"
                                        :class "is-danger"}]}))))

(defn bump-ordinals [questions new-question]
  (map (fn [question]
         (if (and (not= (:id new-question) (:id question))
                  (>= (:ordinal question) (:ordinal new-question)))
           (update question :ordinal inc)
           question))
       questions))

(rf/reg-event-fx
 ::create-question-success
 (fn [{:keys [db]} [_ {:keys [questionnaire-id] :as question}]]
   {:db (-> db
            (update-in [:questionnaires questionnaire-id :questions :data] conj question)
            (assoc-in [:browser-extension :selected-question] question)
            (update-in [:questionnaires questionnaire-id :questions :data] bump-ordinals question))
    :fx [[:dispatch [::send-event {:type :question-created :question question}]]
         [:dispatch [::notifications/add {:message "Question Created"}]]]}))

(rf/reg-event-fx
 ::create-question-failed
 (fn []
   {:dispatch [::notifications/add {:message "Could not create question"
                                    :class "is-danger"}]}))

(rf/reg-event-fx
 ::delete-question-by-content
 (fn [{:keys [db]} [_ content]]
   (let [questionnaire-id (-> db :route :path-params :id uuid)
         ;; Note: This relies that the sender also has determined that content matches.
         ;;       On the injected extension, we don't have the question id's stored currently, so we operate based on text match
         question (some->> (get-in db [:questionnaires questionnaire-id :questions :data])
                           (keep #(when (= (:content %) content) %))
                           first)]
     (if question
       {:dispatch [::delete-question question]}
       {:dispatch [::delete-question-failed nil]}))))

(rf/reg-event-fx
 ::delete-question
 (fn [_ [_ question]]
   (when (js/confirm "Delete this question?")
    {:http-xhrio {:method :delete
                 :uri (str "/api/questions/question/" (:id question) "/")
                 :timeout http-config/timeout
                 :format http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :on-success [::delete-question-success question]
                 :on-failure [::delete-question-failed question]}})))

(rf/reg-event-fx
 ::delete-question-success
 (fn [{:keys [db]} [_ {:keys [questionnaire-id] question-id :id :as question}]]
   (let [selected-question (get-in db [:browser-extension :selected-question])]
     {:db (-> db
              (update-in [:questionnaires questionnaire-id :questions :data]
                         (fn [questions]
                           (->> questions
                                (keep (fn [question]
                                        ;; This removes the question and sets the parent of the children, if any, to nil
                                        (when (not= question-id (:id question))
                                          (cond-> question
                                            (= question-id (:parent-id question)) (assoc :parent-id nil)))))
                                vec)))
              (cond->
                (and selected-question
                     (= question-id (:id selected-question)))
                (update-in [:browser-extension] dissoc :selected-question)))
      :fx [[:dispatch [::notifications/add {:message "Question deleted"}]]
           [:dispatch [::send-event {:type :question-deleted
                                     :question question}]]]})))

(rf/reg-event-fx
 ::delete-question-failed
 (fn [_ [_ question {:keys [status]}]]
   (if (and question (= status 200))
     {:dispatch [::delete-question-success question]}
     {:dispatch [::notifications/add {:message "Could not delete question"
                                      :class "is-danger"}]})))

(rf/reg-event-fx
 ::select-section
 (fn [{:keys [db]} [_ content focus-host-element?]]
   (let [questionnaire-id (-> db :route :path-params :id uuid)
         section (->> (get-in db [:questionnaires questionnaire-id :sections :data])
                      (keep #(when (= (:name %) (:name content)) %))
                      first)]
     (if section
       {:db (-> db
                (assoc-in [:browser-extension :selected-section] section)
                (assoc-in [:browser-extension :selected-question] nil))
        :fx [[:dispatch [::send-event {:type :section-selected
                                       :content section
                                       :questions (get-in db [:questionnaires questionnaire-id :questions :data])
                                       :focus focus-host-element?}]]
             [:dispatch [::send-event {:type :question-selected :content nil :focus focus-host-element?}]]]}
       {:db (-> db
                (assoc-in [:browser-extension :selected-section] nil)
                (assoc-in [:browser-extension :selected-question] nil))
        :fx [[:dispatch [::send-event {:type :section-selected
                                      :content nil
                                      :questions (get-in db [:questionnaires questionnaire-id :questions :data])
                                      :focus focus-host-element?}]]
             [:dispatch [::send-event {:type :question-selected :content nil :focus focus-host-element?}]]]}))))

(rf/reg-event-fx
 ::create-section
 (fn [{:keys [db]} [_ context content]]
   (let [questionnaire-id (-> db :route :path-params :id uuid)
         ; Sending the actual context for a section, in production, is
         ; capturing the whole page, meaning that when we get sections
         ; we are getting n copies of the page, and this would quickly cause
         ; the GET for sections to fail - we do not really need it, so just
         ; send the text
         section {:name content :element-context content}]
     {:http-xhrio {:method :post
                   :uri (str "/api/questionnaires/" questionnaire-id "/sections")
                   :params section
                   :timeout http-config/timeout
                   :format http-config/transit-request-format
                   :response-format http-config/transit-response-format
                   :on-success [::create-section-success questionnaire-id]
                   :on-failure [::create-section-failed]}
      :db (assoc-in db [:browser-extension :selected-question] nil)})))

(rf/reg-event-fx
 ::create-section-success
 (fn [{:keys [db]} [_ questionnaire-id section]]
   {:dispatch [::send-event {:type :section-selected
                             :content section
                             :questions (get-in db [:questionnaires questionnaire-id :questions :data])
                             :question nil
                             :focus true}]
    :db (-> db
            (update-in [:questionnaires questionnaire-id :sections :data] conj section)
            (assoc-in [:browser-extension :selected-section] section)
            (assoc-in [:browser-extension :selected-question] nil))}))

(rf/reg-event-fx
 ::create-section-failed
 (fn [_ [_ _error]]
   {:dispatch [::notifications/add {:messages "Could not define section"
                                    :class "is-danger"}]}))

(rf/reg-event-fx
 ::delete-section-by-content
 (fn [{:keys [db]} [_ content]]
   (when (js/confirm "Delete this Section?")
    (let [questionnaire-id (-> db :route :path-params :id uuid)
         sections (get-in db [:questionnaires questionnaire-id :sections :data])
         section (section-by-name sections content)]
     (if section
       {:dispatch [::delete-section section]}
       {:dispatch [::delete-section-failed]})))))

(rf/reg-event-fx
 ::delete-section
 (fn [_ [_ section]]
   (when (js/confirm "Delete this Section?")
    {:http-xhrio {:method :delete
                 :uri (str "/api/sections/section/" (:id section) "/")
                 :timeout http-config/timeout
                 :format http-config/transit-request-format
                 :response-format http-config/transit-response-format
                 :on-success [::delete-section-success section]
                 :on-failure [::delete-section-failed section]}})))

(rf/reg-event-fx
 ::delete-section-success
 (fn [{:keys [db]} [_ section]]
   (let [questionnaire-id (-> db :route :path-params :id uuid)
         selected-section (get-in db [:browser-extension :selected-section])]
     {:db (-> db
              (update-in [:questionnaires questionnaire-id :sections :data]
                         (fn [sections]
                           (vec (remove #(= (:id %) (:id section)) sections))))
              (update-in [:questionnaires questionnaire-id :questions :data]
                         (fn [questions]
                           (vec (remove #(= (:id section) (:section-id %)) questions))))
              (cond->
                (and selected-section
                     (= (:id section) (:id selected-section)))
                (update-in [:browser-extension] dissoc :selected-section :selected-question)))
      :fx [[:dispatch [::notifications/add {:message "Section deleted"}]]
           [:dispatch [::send-event {:type :section-deleted :section section}]]
           [:dispatch [::send-event {:type :section-selected
                                     :content nil
                                     :questions (get-in db [:questionnaires questionnaire-id :questions :data])
                                     :question nil
                                     :focus false}]]]})))

(rf/reg-event-fx
 ::delete-section-failed
 (fn [_ [_ section {:keys [status]}]]
   (if (= status 200)
     {:dispatch [::delete-section-success section]}
     {:dispatch [::notifications/add {:message "Could not delete section"
                                      :class "is-danger"}]})))

(rf/reg-event-fx
 ::create-answer
 (fn [{:keys [db]} [_ context content input-type input-value]]
   (when (or (-> db :browser-extension :selected-question :selected-answer :response seq not)
             (js/confirm "Overwrite existing response?"))
    (let [questionnaire-id (-> db :route :path-params :id uuid)
          selected-id (-> db :browser-extension :selected-question :id)
          answer-data (->> (get-in db [:questionnaires questionnaire-id :questions :data])
                           (filter (comp (partial = selected-id) :id))
                           first
                           :selected-answer)]
     (if-let [selected-question (-> db :browser-extension :selected-question)]
       (cond
         ;; If the element has content, create a selected answer.
         (#{:input :content-editable :textarea :button :text :select} input-type)
         {:http-xhrio {:method :post
                       :uri (str "/api/questions/question/" (:id selected-question) "/answer")
                       :params {:response (or input-value content)
                                :comment (-> answer-data
                                             :additional-information
                                             (or (:comment answer-data)))
                                :source-system "portal"}
                       :timeout http-config/timeout
                       :format http-config/transit-request-format
                       :response-format http-config/transit-response-format
                       :on-success [::create-answer-success]
                       :on-failure [::create-answer-failed]}}
         (#{:radio :checkbox} input-type)
         {:http-xhrio {:method :post
                       :uri (str "/api/questions/question/" (:id selected-question) "/answer")
                       :params {:response content
                                :element-context context
                                :comment (-> answer-data
                                             :additional-information
                                             (or (:comment answer-data)))
                                :source-system "portal"}
                       :timeout http-config/timeout
                       :format http-config/transit-request-format
                       :response-format http-config/transit-response-format
                       :on-success [::create-answer-success]
                       :on-failure [::create-answer-failed]}}
         :else
         (do
           (println "unimplemented answer type: " input-type)
           {:dispatch [::notifications/add {:message (str "Unimplemented answer type")
                                            :class "is-info"}]}))
       {:dispatch [::notifications/add {:message "Cannot add answer, select a question first"
                                        :class "is-info"}]})))))

(rf/reg-event-fx
 ::create-answer-option
 (fn [{:keys [db]} [_ context content input-type input-checked]]
   (let [questionnaire-id (-> db :route :path-params :id uuid)]
     (if-let [selected-question (-> db :browser-extension :selected-question)]
       {:http-xhrio {:method :post
                     :uri (str "/api/questions/question/" (:id selected-question) "/options")
                     :params {:content content
                              :element-context context
                              :selected (boolean input-checked)
                              :multi (= input-type :checkbox)
                              :source-system "portal"}
                     :timeout http-config/timeout
                     :format http-config/transit-request-format
                     :response-format http-config/transit-response-format
                     :on-success [::create-option-success questionnaire-id (:id selected-question)]
                     :on-failure [::create-option-failed]}}
       {:dispatch [::notifications/add {:message "Cannot add answer, select a question first"
                                        :class "is-info"}]}))))

(rf/reg-event-fx
 ::create-comment
 (fn [{:keys [db]} [_ content input-type input-value]]
   (let [selected-question (-> db :browser-extension :selected-question)]
    (when (or (and (-> selected-question :selected-answer :additional-information seq not)
                   (-> selected-question :selected-answer :comment seq not))
              (js/confirm "Overwrite existing response?"))
     (let [questionnaire-id (-> db :route :path-params :id uuid)
           selected-id (:id selected-question)
           answer-data (->> (get-in db [:questionnaires questionnaire-id :questions :data])
                            (filter (comp (partial = selected-id) :id))
                            first
                            :selected-answer)]
       (if selected-question
         (cond
                 ;; If the element has content, create a selected answer.
           (#{:input :content-editable :textarea :button :radio :checkbox :text :select} input-type)
           {:http-xhrio {:method :post
                         :uri (str "/api/questions/question/" selected-id "/answer")
                         :params {:comment (or input-value content)
                                  :response (:response answer-data)
                                  :source-system "portal"}
                         :timeout http-config/timeout
                         :format http-config/transit-request-format
                         :response-format http-config/transit-response-format
                         :on-success [::create-answer-success]
                         :on-failure [::create-answer-failed]}}
           :else
           (do
             (println "unimplemented answer type: " input-type)
             {:dispatch [::notifications/add
                         {:message (str "Unimplemented answer type")
                          :class "is-info"}]}))
         {:dispatch [::notifications/add
                     {:message "Cannot add answer, select a question first"
                      :class "is-info"}]}))))))

(rf/reg-event-fx
 ::create-answer-success
 (fn [{:keys [db]} [_ answer]]
   (let [questionnaire-id (-> db :route :path-params :id uuid)
         selected-question-id (-> db :browser-extension :selected-question :id)
         q (first (filter
                   (fn [question] (= (:id question) selected-question-id))
                   (get-in db [:questionnaires questionnaire-id :questions :data])))]
     {:db (update-in db
                     [:questionnaires questionnaire-id :questions :data]
                     (fn [questions]
                       (mapv (fn [question]
                               (if (= (:id question) selected-question-id)
                                 (cond-> (assoc question
                                                :selected-answer answer))
                                 question))
                             questions)))
      :fx (cond-> [[:dispatch [::notifications/add {:message "Answer created and captured"}]]]
            (and (str/blank? (:status q))
                 (not (str/blank? (:response answer))))
            (conj [:dispatch [::questionnaire.db/update-question-status
                              questionnaire-id
                              (:id q)
                              "approved"]]))})))

(rf/reg-event-fx
 ::create-answer-failed
 (fn [_ [_]]
   {:dispatch [::notifications/add {:message "Could not create answer"
                                    :class "is-danger"}]}))

(rf/reg-event-fx
 ::create-answer-context-success
 (fn [{:keys [db]} [_ questionnaire-id selected-question-id context]]
   {:db (update-in db
                   [:questionnaires questionnaire-id :questions :data]
                   (fn [questions]
                     (mapv (fn [question]
                             (if (= (:id question) selected-question-id)
                               (assoc question :data context)
                               question))
                           questions)))
    :dispatch [::notifications/add {:message "Answer defined"}]}))

(rf/reg-event-fx
 ::create-answer-context-failed
 (fn [_ [_]]
   {:dispatch [::notifications/add {:message "Could not create answer"
                                    :class "is-danger"}]}))

(rf/reg-event-fx
 ::create-option-success
 (fn [{:keys [db]} [_ questionnaire-id question-id option]]
   {:db (update-in db [:questionnaires questionnaire-id :questions :data]
                   (fn [questions]
                     (mapv (fn [question]
                             (if (= (:id question) question-id)
                               (let [updated-q (update question
                                                       :options
                                                       (fnil conj [])
                                                       (assoc option :ordinal (inc (count questions))))]
                                 (cond-> updated-q
                                   (some? (:selected-answer question))
                                   (assoc-in [:selected-answer :options] (:options updated-q))))
                               question))
                           questions)))
    :dispatch [::notifications/add {:message "Answer option created"}]}))

(rf/reg-event-fx
 ::create-option-failed
 (fn [_ [_]]
   {:dispatch [::notifications/add {:message "Could not create answer option"
                                    :class "is-danger"}]}))

(rf/reg-event-fx
 ::receive-event
 (fn [{:keys [db]} [_ event]]
   (println "received event from host: " (:type event))
   (case (:type event)
     :init-browser-extension {:dispatch [::set-env-history (->> event :env-history (into #{}))]}
     :select-question {:dispatch [::select-question (:content event) false]}
     :define-question {:fx [[:dispatch [::notifications/add {:message "Creating Question"
                                                             :class "is-info"}]]
                            [:dispatch [::create-question (:context event) (:content event) (:follow-up? event)]]]}
     :delete-question {:fx [[:dispatch [::notifications/add {:message "Deleting Question"
                                                             :class "is-info"}]]
                            [:dispatch [::delete-question-by-content (:content event)]]]}
     :select-section {:dispatch [::select-section (:content event) false]}
     :define-section {:fx [[:dispatch [::notifications/add {:message "Creating Section"
                                                            :class "is-info"}]]
                           [:dispatch [::create-section (:context event) (:content event)]]]}
     :delete-section {:dispatch [::delete-section-by-content (:content event)]}
     :define-answer {:fx [[:dispatch [::notifications/add {:message "Creating Response"
                                                           :class "is-info"}]]
                          [:dispatch [::create-answer
                                      (:context event)
                                      (:content event)
                                      (:input-type event)
                                      (:input-value event)]]]}
     :define-answer-option {:fx [[:dispatch [::notifications/add {:message "Creating Answer Option"
                                                                  :class "is-info"}]]
                                 [:dispatch [::create-answer-option
                                             (:context event)
                                             (:content event)
                                             (:input-type event)
                                             (:input-checked event)]]]}
     :define-comment {:fx [[:dispatch [::notifications/add {:message "Creating Comment"
                                                            :class "is-info"}]]
                           [:dispatch [::create-comment
                                       (:content event)
                                       (:input-type event)
                                       (:input-value event)]]]}
     :select-response {:dispatch [::select-response (:content event)]}
     :select-option {:dispatch [::select-option (:content event)]}
     :toggle-extension-expanded {:dispatch [::toggle-extension-expanded (:content event)]}
     (do
       (println "browser-extension: unhandled event type: " (:type event))
       {:db db}))))

(rf/reg-event-fx
 ::send-event
 (fn [_ [_ event]]
   (let [writer (t/writer :json)]
     (when-not (identical? js/window.parent js/window)
       (println "sending event to host: " (:type event))
       (try
         (js/window.parent.postMessage (-> (t/write writer event)) "*")
         (catch js/Error e
           (println "could not send event: " e)))))))

(rf/reg-event-db
 ::toggle-extension-expanded
 (fn [db [_ value]]
   (assoc db :extension-expanded value)))

(rf/reg-sub
 ::is-extension-expanded
 (fn [db [_]]
   (get db :extension-expanded true)))

(defn toggle-extension-expanded
  [value]
  (rf/dispatch [::toggle-extension-expanded value])
  (rf/dispatch [::send-event {:type :toggle-extension-expanded
                              :value value}]))

(defn is-extension-expanded
  []
  (rf/subscribe [::is-extension-expanded]))


(defn is-browser-extension-path? []
  (let [extension-paths #{client-envs-config/view-id
                          questionnaire-list-config/view-id
                          questionnaire-config/view-id
                          new-questionnaire-config/view-id}
        route @(rf/subscribe [::subs/route])]
    (contains? extension-paths (-> route :data :name))))
